export default "__VITE_ASSET__BUoBam9x__"